<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<Props>()
const now = useNow()
const minutesLater = computed(() => now.value.getTime() + 1000 * 60 * 10)

const formattedDate = computed(() => {
  const date = new Date(minutesLater.value)
  return date.toLocaleString('ru-RU', {
    hour: 'numeric',
    minute: 'numeric',
  }).split(':')
})

interface Props {
  class?: HTMLAttributes['class']
  badge?: boolean
}
</script>

<template>
  <div class="relative inline-block w-full">
    <!-- Бейдж "0%" - позиционируется относительно контейнера -->
    <div v-if="props.badge" class="absolute -top-2 -right-3 bg-green-500 text-white text-sm font-bold min-w-[18px] py-0.5 px-1.5 rounded-full flex items-center justify-center border border-white shadow-sm z-20 pointer-events-none">
      0%
    </div>

    <GradientButton :class="props.class">
      <span>
        Получить деньги
      </span>
      <ClientOnly>
        <span>
          в
          {{ formattedDate[0] }}<span :class="{ 'opacity-0': now.getSeconds() % 2 === 0 }">:</span>{{ formattedDate[1] }}
        </span>
      </ClientOnly>
    </GradientButton>
  </div>
</template>

<style scoped>

</style>
